import Link from "next/link";
import styled from "styled-components";

const PageContainerWrapper = styled.section`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 80px 0px;
  margin: 40px 0px;
`;

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: auto;
  border-radius: 6px;
  border: 1px solid #ccc;
  box-shadow: 0px 0px 6px #efefef;
  padding: 40px;
  margin: 40px;
  width: 50%;
  @media (max-width: 425px) {
    width: 100%;
    margin: 15px;
  }
`;

const ErrorPageTitle = styled.h1`
  font-family: "Lato";
  font-size: 24px;
  margin: 10px 0px;
  text-align: center;
  @media (max-width: 425px) {
    font-size: 20px;
  }
`;

const ErrorPageSubtitle = styled.p`
  font-family: "Lato";
  font-size: 18px;
  font-weight: normal;
  margin: 10px 0px;
  text-align: center;
  a {
    text-decoration: none;
    font-weight: 600;
    color: #f86a6e;
  }
  @media (max-width: 425px) {
    font-size: 16px;
  }
`;

const BASE_PATH = process.env.BASE_PATH;

export default function Custom500() {
  return (
    <PageContainerWrapper>
      <ErrorContainer>
        <img
          src={`${BASE_PATH}/images/Footer-Logo.svg`}
          alt="logo-image"
          title="logo-image"
          width="85px"
          height="85px"
        />
        <ErrorPageTitle>Sorry, something went wrong!</ErrorPageTitle>
        <ErrorPageSubtitle>
          There is a problem loading the page.
        </ErrorPageSubtitle>
        <ErrorPageSubtitle>
          <Link href="javascript:window.location.reload(true)">Try Again</Link>
        </ErrorPageSubtitle>
      </ErrorContainer>
    </PageContainerWrapper>
  );
}
